let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gFjqZ")).then(() => parcelRequire('48Ka6'));